"use client";

import React, { useEffect } from "react";
import { MenuButton } from "./MenuButton";
import { Menu } from "@/app/[locale]/components";
import { motion, useCycle } from "framer-motion";
import Image from "next/image";
import { languages } from "@/app/constants";

import ContactIcon from "./ContactIcon";
import FastMenu from "../menu/FastMenu";
import SocialMedia from "./SocialMedia";
import { Link } from "@/app/config/navigation";
import Languages from "../footer/Languages";
import Language from "../footer/Language";
import { NavLogo } from "../../logo/NavLogo";
import { useTranslations } from "next-intl";

const language = languages[languages.length - 1];
function DesktopContainer({ children }: SidebarPropsType) {
  const [isOpen, toggleOpen] = useCycle(false, true);
  const [openLanguages, toggleOpenLanguages] = useCycle(false, true);
  const opendLanguagesList = languages.slice(0, languages.length - 1);
  const t = useTranslations("layout");

  useEffect(() => {
    if (typeof window != "undefined") {
      if (isOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflowY = "unset";
      }
    }
  }, [isOpen]);

  return (
    <div className="fixed z-[10000] bg-primary  w-max h-full">
      <motion.div
        initial={{ width: "10rem" }}
        variants={{
          open: {
            width: "100vw",
          },
          closed: {
            width: "10rem",
          },
        }}
        animate={isOpen ? "open" : "closed"}
        transition={{ duration: 0.2 }}
        className="  overflow-hidden"
      >
        <div className=" py-[54px]  bg-primary  h-screen  flex relative">
          <div className="flex w-full">
            <div className="w-[10rem]  flex-shrink-0">
              {" "}
              <div className="flex flex-col justify-center gap-[4.5rem]  items-center w-full relative  ">
                <NavLogo
                  onClick={isOpen ? toggleOpen : undefined}
                  open={isOpen}
                />
                <MenuButton open={isOpen} toggleOpen={() => toggleOpen()} />
              </div>{" "}
              <div
                className={`w-full mt-11  transition-all  duration-100 ${
                  isOpen && " opacity-0"
                }`}
              >
                <FastMenu />
              </div>
            </div>
            <div
              className={`w-full   ${
                isOpen ? "transition-all  duration-300" : " opacity-0"
              }`}
            >
              <Menu menuOnClick={toggleOpen} />
            </div>
          </div>

          <motion.div
            initial={{ height: "15rem" }}
            variants={{
              open: {
                width: "100vw",
                height: "15.4rem",
              },
              closed: {
                height: "15rem",
                width: "10rem",
              },
              openLanguages: {
                height: `${14 + languages.length * 3}rem`,
              },
            }}
            animate={
              isOpen ? "open" : openLanguages ? "openLanguages" : "closed"
            }
            transition={{ duration: 0.2 }}
            className=" bg-secondary py-5  pt-8  max-h-[80%] z-50 pb-10 pe- overflow-hidden flex  justify-between absolute !w-full bottom-0  "
          >
            <div className="w-[10rem] flex flex-col gap-[2rem] flex-shrink-0 justify-end items-center">
              {" "}
              <div className="flex flex-col relative   px-4 h-max  w-full ml-auto">
                {" "}
                <button
                  className={`absolute left-0 w-full h-0 p-[12px] top-[-3rem] pt-[14px] ${
                    openLanguages && "top-[-5rem]"
                  } ${isOpen && "hidden"} `}
                  onClick={() => toggleOpenLanguages()}
                >
                  <Image
                    width={11.6}
                    height={11.6}
                    className={`w-8 m-auto transition-all md:w-3  pb-8  ease-in-out duration-200 ${
                      openLanguages ? " rotate-180" : ""
                    }`}
                    src="/icons/arrowTop.svg"
                    alt="Toggle language options"
                  />
                </button>
                <div
                  className={`flex ps-[2.6rem]     w-full ${
                    !isOpen ? "flex-col-reverse" : "flex-row"
                  }`}
                >
                  <Language {...language} key={language.key} />
                  <div className={`  ${isOpen ? "w-auto " : "w-0"}`}>
                    <div
                      className={`-translate-x-10 gap-5  transition-all ps-5  ease-in-out w-0  h-0  duration-300  flex${
                        isOpen && " translate-x-0  h-auto"
                      }`}
                    >
                      <Languages languages={opendLanguagesList} />
                    </div>
                  </div>
                  <div
                    className={` gap-5 flex-col   opacity-0 overflow-hidden   h-0 ${
                      openLanguages && "opacity-100 h-auto pb-5"
                    } ${isOpen && " hidden"}`}
                  >
                    <Languages languages={opendLanguagesList} />
                  </div>
                </div>
              </div>
              <div>
                {" "}
                <ContactIcon className="mx-auto" />
              </div>
            </div>
            <div
              className={`flex flex-col gap-[2rem] justify-end pe-[18rem] ${
                !isOpen && " opacity-0"
              }`}
            >
              <SocialMedia />
              <div className="flex  gap-11 text-gray200  text-[12px] lg:text-[1.5rem]">
                <Link onClick={()=>toggleOpen()} href="/privacy-policy" className="">
                  {t("privacyPolicy")}
                </Link>
                <Link onClick={()=>toggleOpen()} href="/terms-and-conditions" className="">
                  {t("termsConditions")}
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
}
export default DesktopContainer;

export type SidebarPropsType = {
  children?: JSX.Element;
};
